import { GetApp } from "@mui/icons-material"
import { Button } from "@mui/material"
import { LoadingButton } from "components/Button"
import ErrorDialog from "components/ErrorDialog"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { ExportExcelProps, TableLoadingStateEnum } from "../tableProps.interface"
import useTableExport from "../useTableExport"

const ExportToExcel: FC<ExportExcelProps> = ({ convertedTable }) => {
  const [exportTableState, exportTable] = useTableExport()
  const { t } = useTranslation()

  return (
    <>
      {exportTableState === TableLoadingStateEnum.Error && (
        <ErrorDialog
          title={t("global.export_failed", "The export failed")}
          message={t("global.export_failed_message", "The export failed, reduce the size of the data using the filters and try again.")}
        />
      )}
      {exportTableState === TableLoadingStateEnum.Loading ? (
        <LoadingButton />
      ) : (
        <Button
          color="primary"
          startIcon={<GetApp />}
          onClick={() => {
            exportTable(convertedTable as any)
          }}>
          <span>{t("global.table.export", "Export")}</span>
        </Button>
      )}
      {/* {print && (
                  <PDFDownloadLink
                    document={
                      <PrintTemplate
                        columns={columns}
                        data={rows}
                        // prepareRow={prepareRow}
                        // printTitle={printTitle}
                      />
                    }
                    fileName="Planering.pdf"
                    style={{ textDecoration: "none" }}>
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        <Button>Laddar utskrift...</Button>
                      ) : (
                        <Button color="primary" startIcon={<Print />}>
                          Skriv ut
                        </Button>
                      )
                    }
                  </PDFDownloadLink>
                )} */}
    </>
  )
}

export default ExportToExcel
